import { createSlice } from "@reduxjs/toolkit";

const initialPortState = {
  listLoading: false,
  actionsLoading: false,
  totalCount: 0,
  entities: null,
  meta: {total : 0},
  links: null,
  lastError: null,
  portForEdit: undefined,
};

export const callTypes = {
  list: "list",
  action: "action",
};

export const portSlice = createSlice({
  name: "port",
  initialState: initialPortState,
  reducers: {
		catchError: (state, action) => {
      state.error = `${action.type}: ${action.payload.error}`;
      if (action.payload.callType === callTypes.list) {
        state.listLoading = false;
      } else {
        state.actionsLoading = false;
      }
    },
    startCall: (state, action) => {
      state.error = null;
      if (action.payload.callType === callTypes.list) {
        state.listLoading = true;
      } else {
        state.actionsLoading = true;
      }
    },
		portFetched: (state, action) => {
      const { entities, meta, links } = action.payload;
      state.listLoading = false;
      state.error = null;
      state.entities = entities;
      state.meta = meta;
      state.links = links;
    },
		portAllFetched: (state, action) => {
      const { count, entities } = action.payload;
      state.listLoading = false;
      state.error = null;
      state.entities = entities;
      state.totalCount = count;
    },
    portCreated: (state, action) => {
      state.actionsLoading = false;
      state.error = null;
      state.entities.port.push(action.payload.port);
    },
    portDeleted: (state, action) => {
      state.error = null;
      state.actionsLoading = false;
      state.entities = state.entities.port.filter(el => el.port_id !== action.payload.id);
    },
    getPort: (state, action) => {
      state.actionsLoading = false;
      state.portForEdit = action.payload.portForEdit;
      state.error = null;
    },
    // updateProduct
    portUpdated: (state, action) => {
      state.error = null;
      state.actionsLoading = false;
      state.entities.port = state.entities.port.map(entity => {
        if (entity.port_id === action.payload.port.port_id) {
          return action.payload.port;
        }
        return entity;
      });
    },
  },
});
